import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/centralian-pythons.json";
import { animalGridFromJson } from "hooks/useGallery";
// Bulk image album

const animalGridData = animalGridFromJson(collectionMeta);

const CentralianPython = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Centralian Pythons (Morelia bredli)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/centralian-pythons" />
      </Helmet>

      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />

      <AnimalGrid data={animalGridData} />

      <BodyText>
        Centralian, or Bredl's, pythons are relatively new for me. I have two of
        the "pure hypo" Bredl's from Nick Mutton and they are absolutely
        gorgeous animals. I had heard that Bredl's were the tamest carpet
        pythons but apparently the hypomelanistic gene that I've bought into can
        be a bit flighty. Still, I have never been bitten by one - partly
        because I can dodge their strikes so well - but they are calming down
        with time. So maybe they have to get through the nippy phase that all
        carpet pythons go through in their first two years or so.
      </BodyText>

      <BodyText>
        Mine are in their grow-up cages which have perches and are close to the
        door in and out of my reptile room so they are on display constantly and
        are amazing to see. I hope to breed them in 2024 and so I will need them
        in their bigger cages by then. During the winter of 2022/23 I brumated
        them for 3 months by placing them in a 50-55 F room at night and then
        bringing them back into the snake room and letting them sit with just
        ambient heat at 70-73 F during the day. Then I'd move them back at
        night. I intend to do this every year for them.
      </BodyText>

      <BodyText>
        I should mention that I did get a baby Bredl's python as a trade in
        2017. We named her Dark Life mainly because of the life choices she made
        while she was with us. She was definitely in her early, ugly phase but
        she was also difficult to get feeding. After about 9 months she did
        start eating for a few months, only to stop and basically request
        death-by-starvation, which was granted to her a few months later.
      </BodyText>

      <PageGallery slug="centralian-pythons" maxWidth="900" />
    </ContentBox>
  );
};

export default CentralianPython;
